import LegalDocViewer from "@/components/LegalDocViewer";
import content from "@/legal-rendered/cookie_policy";

export default function CookiePolicyPage() {
  return (
    <LegalDocViewer
      title="Cookie Policy"
      subtitle="Cookies, similar technologies and your choices"
      policyId="cookie_policy"
      policyVersion="1.1.0"
      content={content}
    />
  );
}
